import actionCreatorFactory from "typescript-fsa";

import {Ganymede} from "@slices/Ganymede/ClientManager";
import {routeActions} from "src/utils/router";


const actionCreator = actionCreatorFactory('routes/projects/project');

export const projectRoute = routeActions<{id: string}>(actionCreator);

export const getClients =
  actionCreator.async<{projectId: string}, Ganymede.Client[]>('GET_CLIENTS');

export const createClientClicked = actionCreator('CREATE_CLIENT_CLICKED');
export const cancelCreateClicked = actionCreator('CANCEL_CREATE_CLICKED');

export const newClientNameChanged =
  actionCreator<string>('NEW_CLIENT_NAME_CHANGED');

export const createClientSubmitted =
  actionCreator('CREATE_CLIENT_SUBMITTED');

export const createClient = actionCreator.async<{
  projectId: string;
  name: string;
}, Ganymede.Client>('CREATE_CLIENT');

export const clientClicked = actionCreator<{row: number}>('CLIENT_CLICKED');

export const clientDialogClosed = actionCreator('CLIENT_DIALOG_CLOSED');

export const generateTokenClicked = actionCreator('GENERATE_TOKEN_CLICKED');

export const createClientToken = actionCreator.async<{
  projectId: string;
  name: string;
}, {token: string}>('CREATE_CLIENT_TOKEN');



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/routes/projects/project/Project.actions.ts